import 'client-only';

import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

import { csrfHandler } from './csrfHandler';
import type { AxiosBuilderInterceptor } from './types';

export const defaultInterceptors = () => [csrfHandler];
/**
 * Construct a Axios instance with our required config and interceptors.
 */
export const buildAxiosInstance = (
  interceptors?: Array<(axios: AxiosInstance) => AxiosBuilderInterceptor>,
  config?: AxiosRequestConfig,
): AxiosInstance => {
  const instance = axios.create({
    timeout: 30000, // 30 seconds - helps prevent indefinite hangs on mobile
    ...config,
  });

  (interceptors ?? defaultInterceptors()).forEach((create) => {
    const interceptor = create(instance);

    if (interceptor.type === 'request') {
      instance.interceptors.request.use(
        interceptor.handler,
        interceptor.errorHandler ?? Promise.reject,
      );
    } else {
      instance.interceptors.response.use(
        interceptor.handler,
        interceptor.errorHandler ?? Promise.reject,
      );
    }
  });

  return instance;
};
